import { render, staticRenderFns } from "./electric-charge-add-ammeter.vue?vue&type=template&id=a973dc0c&scoped=true&"
import script from "./electric-charge-add-ammeter.vue?vue&type=script&lang=js&"
export * from "./electric-charge-add-ammeter.vue?vue&type=script&lang=js&"
import style0 from "./electric-charge-add-ammeter.vue?vue&type=style&index=0&id=a973dc0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a973dc0c",
  null
  
)

export default component.exports